import { FilterablePayoutTransactionTable } from '@/components/Payouts/FilterablePayoutTransactionTable';
import { PayoutTransactionFilterName } from '@/components/Payouts/PayoutTransactionsFilter';
import { PayoutTransactionTableColumnName } from '@/components/Payouts/PayoutTransactionTable';
import { ProjectTransactionButton } from '@/components/Payouts/ProjectTransactionsButtonBar';
import { Box, Card } from '@palmetto/palmetto-components';

import { getProjectTransactionsQuery, PayoutTransactionLevel } from 'types';
import type { ProjectTransactionSort } from 'types';

const PAYEE_HIDDEN_FILTERS: PayoutTransactionFilterName[] = [
  'projectName',
  'payoutEvent',
  'clawbackRuleName',
  'projectExternalId',
  'programType',
  'pauseExpirationDate',
  'pausedDueToPaymentPlan',
  'payeeType',
  'transactionLevel',
];

const PAYEE_HIDDEN_SORTS: ProjectTransactionSort[] = [
  'projectNameAsc',
  'projectNameDesc',
  'projectExternalIdAsc',
  'projectExternalIdDesc',
  'pausedExpirationDateAsc',
  'pausedExpirationDateDesc',
];

const PAYEE_LOCKED_FILTERS: getProjectTransactionsQuery = { transactionLevel: PayoutTransactionLevel.payee };

const PAYEE_HIDDEN_COLUMNS: PayoutTransactionTableColumnName[] = [
  'project.name',
  'projectExternalId',
  'pauseExpirationDate',
  'transactionLevel',
];

const PAYEE_ENABLED_BUTTONS: ProjectTransactionButton[] = ['addTransaction', 'export'];

export const PayeeTransactions = () => (
  <Card padding="xs" marginTop="0">
    <Card.Header>
      <Box fontSize="xl" fontWeight="medium">
        Organization Transactions
      </Box>
    </Card.Header>
    <Box margin="0 lg lg lg">
      <FilterablePayoutTransactionTable
        lockedQueryFilters={PAYEE_LOCKED_FILTERS}
        transactionLevel={PayoutTransactionLevel.payee}
        defaultSort="eventDateDesc"
        enabledButtons={PAYEE_ENABLED_BUTTONS}
        hideColumns={PAYEE_HIDDEN_COLUMNS}
        hideFilters={PAYEE_HIDDEN_FILTERS}
        hideSort={PAYEE_HIDDEN_SORTS}
        searchPlaceholder="Search by Organization, Amount"
        showPagination
        showExpandedRow
        showContextMenu
        disableSelection
      />
    </Box>
  </Card>
);
